import { render, staticRenderFns } from "./WriteTips.vue?vue&type=template&id=1ed85c3c"
import script from "./WriteTips.vue?vue&type=script&lang=js"
export * from "./WriteTips.vue?vue&type=script&lang=js"
import style0 from "./WriteTips.vue?vue&type=style&index=0&id=1ed85c3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports